module.exports = "<div #mapContainer id=\"map\"></div>\r\n"